import { MockedRequest, rest } from 'msw';
import { makeListResults } from 'test-util/api/response';
import { getEnv } from 'util/getEnv';
import {
  CreateEmailTemplateRequest,
  EmailTemplateType,
  UpdateEmailTemplateRequest,
} from './email-template-service.types';
import { emailTemplateRelatedItems } from './fixtures/email-template-related-item.fixtures';
import {
  emailTemplates,
  mergeTags,
  newEmailTemplate,
} from './fixtures/email-template.fixtures';
import { v4 as uuidv4 } from 'uuid';

export const baseUrl = 'incentivio-client-domain/templates';

export const listEmailTemplatesMock = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}`, fn);

export const createEmailTemplateMock = fn =>
  rest.post(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}`, fn);

export const listEmailTemplatesMergeTags = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}/tags`, fn);

export const getEmailTemplateMock = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}/:id`, fn);

export const updateEmailTemplateMock = fn =>
  rest.put(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}/:id`, fn);

export const deleteEmailTemplateMock = fn =>
  rest.delete(`${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}/:id`, fn);

export const listEmailTemplateRelatedItemsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/${baseUrl}/:id/associations`,
    fn,
  );

export const handlers = () => [
  listEmailTemplatesMock((req, res, ctx) => {
    const url = new URL(req.url);
    const emailTemplateType: EmailTemplateType = url.searchParams.get(
      'emailTemplateType',
    ) as EmailTemplateType;
    const reusable = url.searchParams.get('reusable');
    const filtered = emailTemplates.filter(
      template =>
        template.emailTemplateType === emailTemplateType &&
        template.reusable === (reusable === 'true'),
    );

    return res(
      ctx.json(
        makeListResults(filtered, req.url.searchParams, {
          listName: 'templates',
        }),
      ),
    );
  }),

  createEmailTemplateMock(
    (req: MockedRequest<CreateEmailTemplateRequest>, res, ctx) => {
      const newTemplate = {
        ...newEmailTemplate,
        ...req.body,
        templateId: uuidv4(),
      };
      emailTemplates.push(newTemplate);
      return res(ctx.json(newTemplate));
    },
  ),

  listEmailTemplatesMergeTags((_req, res, ctx) => {
    return res(ctx.json(mergeTags));
  }),

  getEmailTemplateMock((req, res, ctx) => {
    return res(
      ctx.json(
        emailTemplates.find(
          emailTemplate => emailTemplate.templateId === req.params.id,
        ),
      ),
    );
  }),

  updateEmailTemplateMock(
    (req: MockedRequest<UpdateEmailTemplateRequest>, res, ctx) => {
      return res(ctx.json({ response: req.body }));
    },
  ),

  deleteEmailTemplateMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listEmailTemplateRelatedItemsMock((_req, res, ctx) => {
    return res(ctx.json(emailTemplateRelatedItems));
  }),
];
